import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { PrintService } from 'src/app/services/print.service';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AddReadingTypeComponent } from '../add-reading-type/add-reading-type.component';

@Component({
  selector: 'app-reading-type',
  templateUrl: './reading-type.component.html',
  styleUrls: ['./reading-type.component.scss']
})
export class ReadingTypeComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TESTING_CENTER.AUDIO_READING;
  DISPLAY_STATUS_KEY: any;

  constructor(
    public store: BookstoreStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.DISPLAY_STATUS_KEY = STATUS_OBJECT['submitted'];
    this.store.fetchData(COLLECTION_NAME.READING_TYPE, this.DISPLAY_STATUS_KEY.key)
  }

  create(item?: any) {
    let dialogRef = this.dialog.open(AddReadingTypeComponent, {
      data: {
        ITEM: item || null,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { 
    });
  }

  delete(item) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: { title: 'Delete Level', memo: '', name: item.title },
      width: '35vw',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.deleteItem(COLLECTION_NAME.READING_TYPE, item, (success, error) => {
          if (success) {
            this.snackBar.open('Type has been removed successfully.', 'done', { duration: 2000 });
          }
          else {
            this.snackBar.open(error, 'Error')
          }
        })
      }
    });
  }


}
